import { _creditForCaseToCase } from '@custom/Utils/constants/apiUrls';
import { createAsyncThunk } from '@reduxjs/toolkit';

export const deleteCaseCredit = createAsyncThunk(
  'creditForCaseToCase/delete',
  async ({ id }: { id: string }, thunkAPI) => {
    try {
      const token = sessionStorage.getItem('token') || localStorage.getItem('token');
      const response = await fetch(_creditForCaseToCase.delete, {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
        body: JSON.stringify({ id }),
      });

      if (!response.ok) return thunkAPI.rejectWithValue('Failed to delete case credit');
      return await response.json();
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);
